import { getCommonAncestor, getCurrentContext } from "./utils";
export const translateEvent = (stage, e) => {
    var _a, _b;
    const { currentElement, canvasOffsetX, canvasOffsetY } = getCurrentContext(e, stage);
    const currentNode = currentElement === null || currentElement === void 0 ? void 0 : currentElement.element.data;
    return {
        cancelBubble: false,
        // Event
        type: e.type,
        currentTarget: currentNode !== null && currentNode !== void 0 ? currentNode : null,
        target: currentNode !== null && currentNode !== void 0 ? currentNode : null,
        // MouseEvent
        canvasOffsetX: canvasOffsetX,
        canvasOffsetY: canvasOffsetY,
        elementOffsetX: (_a = currentElement === null || currentElement === void 0 ? void 0 : currentElement.offsetX) !== null && _a !== void 0 ? _a : 0,
        elementOffsetY: (_b = currentElement === null || currentElement === void 0 ? void 0 : currentElement.offsetY) !== null && _b !== void 0 ? _b : 0,
        currentElement: currentElement,
        originalEvent: e,
    };
};
// https://www.w3.org/TR/uievents/#events-mouse-types
const dispatchMouseEvent = (stage, eventState) => {
    return (e) => {
        const translatedEvent = translateEvent(stage, e);
        dispatchVugelMouseEvent(translatedEvent, eventState);
        // Prevent selecting nearby text when double-clicking on the canvas.
        e.preventDefault();
    };
};
export const dispatchVugelMouseEvent = (translatedEvent, eventState) => {
    var _a;
    const prevNode = eventState.activeNode;
    const currentNode = (_a = translatedEvent.currentElement) === null || _a === void 0 ? void 0 : _a.element.data;
    switch (translatedEvent.type) {
        case "auxclick":
        case "click":
        case "contextmenu":
        case "dblclick":
        case "mousedown":
        case "mouseup": {
            currentNode === null || currentNode === void 0 ? void 0 : currentNode.dispatchBubbledEvent(translatedEvent);
            break;
        }
        case "mouseenter": {
            eventState.activeNode = undefined;
            if (currentNode) {
                eventState.activeNode = currentNode;
                currentNode.dispatchBubbledEvent(translatedEvent, true);
            }
            break;
        }
        case "mouseover": {
            eventState.activeNode = undefined;
            if (currentNode) {
                eventState.activeNode = currentNode;
                currentNode === null || currentNode === void 0 ? void 0 : currentNode.dispatchBubbledEvent(translatedEvent);
            }
            break;
        }
        case "mouseleave": {
            prevNode === null || prevNode === void 0 ? void 0 : prevNode.dispatchBubbledEvent(translatedEvent, true);
            break;
        }
        case "mouseout": {
            prevNode === null || prevNode === void 0 ? void 0 : prevNode.dispatchBubbledEvent(Object.assign(Object.assign({}, translatedEvent), { target: prevNode }));
            break;
        }
        case "mousemove": {
            if (currentNode !== undefined && prevNode != currentNode) {
                const commonAncestor = getCommonAncestor(prevNode, currentNode);
                prevNode === null || prevNode === void 0 ? void 0 : prevNode.dispatchBubbledEvent(Object.assign(Object.assign({}, translatedEvent), { type: "mouseout", target: prevNode }));
                prevNode === null || prevNode === void 0 ? void 0 : prevNode.dispatchBubbledEvent(Object.assign(Object.assign({}, translatedEvent), { type: "mouseleave", target: prevNode }), commonAncestor);
                currentNode.dispatchBubbledEvent(Object.assign(Object.assign({}, translatedEvent), { type: "mouseover" }));
                currentNode.dispatchBubbledEvent(Object.assign(Object.assign({}, translatedEvent), { type: "mouseenter" }), commonAncestor);
            }
            // Mousemove
            currentNode === null || currentNode === void 0 ? void 0 : currentNode.dispatchBubbledEvent(translatedEvent);
            eventState.activeNode = currentNode;
        }
    }
};
export const mouseEventTranslator = {
    auxclick: "onAuxclick",
    click: "onClick",
    contextmenu: "onContextmenu",
    dblclick: "onDblclick",
    mousedown: "onMousedown",
    mouseenter: "onMouseenter",
    mouseleave: "onMouseleave",
    mousemove: "onMousemove",
    mouseout: "onMouseout",
    mouseover: "onMouseover",
    mouseup: "onMouseup",
};
export const setupMouseEvents = (targetElement, stage) => {
    const eventState = {};
    for (const key in mouseEventTranslator) {
        targetElement.addEventListener(key, dispatchMouseEvent(stage, eventState));
    }
};
//# sourceMappingURL=mouseEvents.js.map